//Funktion bindet den Ladebalken als animiertes gif ein
export function addLoader(form) {

    const loader = '/frontend_build/images/icons/ladebalken.gif';
    const buttons = form.querySelectorAll('button');

    // Ladebalken einfügen
    if (!form.querySelector('.loader')) {
        const img = document.createElement('img');
        img.src = loader;
        img.alt = 'Wird gesendet...';
        img.classList.add('loader');
        form.appendChild(img);
    }

    buttons.forEach((el) => {
        el.disabled = true;
        el.classList.add('disabled');
    })
}

export function removeLoader(form) {

    const loader = form.querySelector('.loader');
    const buttons = form.querySelectorAll('button');

    // Ladebalken einfügen
    loader.remove();

    buttons.forEach((el) => {
        el.disabled = false;
        el.classList.remove('disabled');
    })
}

export function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    const value = bytes / Math.pow(1024, i);
    return value.toFixed(1) + ' ' + sizes[i];
}